import { useState, useEffect, useCallback, useRef } from "react";
import FormOperazione from "./FormOperazione";

import { API } from "../config";

// ── Colori stati (5 stati nuovi, mappati dai vecchi nomi DB) ────
const STATO_COLORI = {
  "-":                   { bg: "#E8F5E9", color: "#2E7D32", label: "Confermato", tip: "" },
  "Confermato":          { bg: "#E8F5E9", color: "#2E7D32", label: "Confermato", tip: "" },
  "Confermato Live":     { bg: "#E8F5E9", color: "#2E7D32", label: "Confermato", tip: "" },
  "Da Confermare":       { bg: "#FFF8E1", color: "#F57F17", label: "In attesa", tip: "In attesa della verifica automatica sulle quote ore 8" },
  "Da Confermare Live":  { bg: "#FFF3E0", color: "#E65100", label: "Verifica pre-match", tip: "Verificare la condizione sul bookmaker 5 minuti prima dell'inizio dell'evento" },
  "NON Confermato":      { bg: "#FFEBEE", color: "#C62828", label: "Non confermato", tip: "" },
  "NON Confermato Live": { bg: "#FFEBEE", color: "#C62828", label: "Non confermato", tip: "" },
  "Cancellato":          { bg: "#F5F5F5", color: "#757575", label: "Cancellato", tip: "Partita annullata o rinviata" },
};

// ── Icone mail ──────────────────────────────────────────────────
// D816 v219 — voce speciale della tendina Strategia: non e' una strategia,
// e' l'insieme dei sistemi accesi che nessuna strategia attiva aggancia.
const FUORI_STRATEGIA = "__fuori_strategia__";

const MAIL_ICONE = {
  "Da Inviare": { icon: "⏳", color: "#9E9E9E", tip: "In attesa di invio" },
  "Inviata":    { icon: "✅", color: "#4CAF50", tip: "Email inviata" },
};

// ── Label stati per badge e dropdown ────────────────────────────
const STATO_LABEL_MAP = {
  "Confermato": "🟢 Confermato",
  "In attesa": "🟡 In attesa",
  "Verifica pre-match": "🟠 Verifica pre-match",
  "Non confermato": "🔴 Non confermato",
  "Cancellato": "⚪ Cancellato",
  "Già disputate": "Già disputate",
};

// ── Icone per tipo operazione pipeline ─────────────────────
const TIPO_ICONE = {
  "import-daily":           { icon: "📥", label: "Import Daily",        tip: "Quote ore 8 aggiornate giornalmente" },
  "import-marven":          { icon: "📥", label: "Import Mar-Ven",      tip: "Quote ore 9 e 5mKO importate dal bucket il venerdì e il martedì mattina" },
  "import-risultati":       { icon: "⚽", label: "Import Risultati",    tip: "Risultati HT/FT aggiornati da SoccerSTATs" },
  "ricalcola-selezioni":    { icon: "🔄", label: "Ricalcola Selezioni", tip: "Selezione delle partite previste dai sistemi validati" },
  "mail-programma":         { icon: "📨", label: "Mail Programma",      tip: "Email con il programma partite del ciclo corrente" },
  "mail-aggiornamento":     { icon: "📨", label: "Mail Aggiornamento",  tip: "Email giornaliera con l'aggiornamento del programma delle partite con quote ore 8" },
  "mail-bilancio":          { icon: "📊", label: "Mail Bilancio",       tip: "Email con il bilancio del ciclo appena concluso" },
  "mail-ripristino-ciclo":  { icon: "📨", label: "Mail Ripristino",     tip: "Mail inviata agli utenti dopo modifica manuale delle quote" },
  "mail-selezioni":         { icon: "📨", label: "Mail Selezioni",      tip: "" },
  "notifica-errori":        { icon: "📨", label: "Mail Errori",         tip: "Email di notifica errori pipeline" },
  // ── v164: pipeline introdotte da TASK 17 (gestione pausa estiva) ────
  "vigile-periodo":         { icon: "🛡", label: "Controllo stato sistema",     tip: "Controllo automatico mattutino: verifica se la stagione è attiva o conclusa e decide se le pipeline del giorno devono partire o restare sospese" },
  "watchdog-periodo":       { icon: "🔍", label: "Controllo settimanale attività", tip: "Controllo settimanale (ogni domenica): verifica che tutte le pipeline abbiano girato negli ultimi 8 giorni" },
  "mail-watchdog":          { icon: "📨", label: "Mail riepilogo settimanale",  tip: "Email settimanale con il riepilogo dello stato di tutte le pipeline" },
  "mail-pausa-estiva":      { icon: "📨", label: "Mail pausa estiva",           tip: "Email automatica quando il sistema entra in pausa estiva (stagione conclusa + 7 giorni di margine)" },
  "mail-stagione-al-via":   { icon: "📨", label: "Mail nuova stagione",         tip: "Email automatica all'avvio della nuova stagione, quando il sistema si risveglia dalla pausa estiva" },
};
function getTipoInfo(tipo) {
  if (!tipo) return { icon: "⚙", label: tipo || "—" };
  const key = tipo.toLowerCase().replace(/[\s_]+/g, "-");
  return TIPO_ICONE[key] || { icon: "⚙", label: tipo };
}

// v104 — descrizione automatica per colonna "Descrizione" in cronologia.
// Basata sul tipo operazione; per import-marven distingue via orario
// (≤ 08:00 = import 5mKO giorno precedente della routine mattina;
//  > 08:00 = import quote ore 9 nuovo ciclo della routine mar/ven).
function getDescrizioneOperazione(log) {
  if (!log || !log.tipo) return "";
  const key = String(log.tipo).toLowerCase().replace(/[\s_]+/g, "-");
  if (key === "import-marven") {
    let ora = null;
    if (log.eseguito_at) {
      // Formato Supabase: "2026-03-20 08:15:41.060132" — estraggo ore (pos 11-13)
      try {
        const s = String(log.eseguito_at);
        const part = s.split(" ")[1] || s.split("T")[1] || "";
        const hh = parseInt(part.substring(0, 2), 10);
        if (!isNaN(hh)) ora = hh;
      } catch (e) { ora = null; }
    }
    if (ora !== null && ora <= 8) return "Quote 5mKO partite di ieri";
    return "Quote 1X2 ore 9 nuovo ciclo";
  }
  const map = {
    "import-daily":          "Quote ore 8 partite di oggi",
    "import-risultati":      "HT/FT da SoccerSTATs",
    "ricalcola-selezioni":   "Verifica condizioni pending + aggiornamento selezioni",
    "mail-programma":        "Programma ciclo inviato agli utenti",
    "mail-aggiornamento":    "Aggiornamento giornaliero inviato agli utenti",
    "mail-bilancio":         "Bilancio ciclo inviato agli utenti",
    "mail-ripristino-ciclo": "Aggiornamento ingressi a mercato per modifica manuale quote",
    "mail-selezioni":        "Mail selezioni inviata agli utenti",
    "notifica-errori":       "Notifica errori pipeline all'admin",
    // ── v164: pipeline introdotte da TASK 17 (gestione pausa estiva) ────
    "vigile-periodo":        "Verifica stato sistema (attivo/sospeso)",
    "watchdog-periodo":      "Verifica settimanale attività automatiche",
    "mail-watchdog":         "Riepilogo settimanale stato pipeline",
    "mail-pausa-estiva":     "Sistema entrato in pausa estiva",
    "mail-stagione-al-via":  "Sistema riattivato per nuova stagione",
  };
  return map[key] || "";
}

// ── Stili comuni ────────────────────────────────────────────────
const FONT = "'DM Sans', sans-serif";
const MONO = "'IBM Plex Mono', monospace";

const stili = {
  pagina: {
    padding: "24px 32px", fontFamily: FONT,
    background: "#FAFBFC", minHeight: "100vh",
  },
  titolo: {
    fontSize: 22, fontWeight: 700, color: "#1E293B",
    margin: "0 0 20px 0",
  },
  card: {
    background: "#fff", borderRadius: 10,
    border: "1px solid #E2E8F0",
    padding: "16px 20px", marginBottom: 16,
  },
  label: {
    fontSize: 11, fontWeight: 600, color: "#64748B",
    marginBottom: 4, display: "block", fontFamily: FONT,
  },
  select: {
    fontFamily: FONT, fontSize: 13, padding: "6px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", minWidth: 140,
    outline: "none",
  },
  input: {
    fontFamily: FONT, fontSize: 13, padding: "6px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", width: 120,
  },
  btn: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "7px 16px", borderRadius: 6, border: "none",
    cursor: "pointer", transition: "background 0.15s",
  },
  btnPrimary: {
    background: "#2563EB", color: "#fff",
  },
  btnSecondary: {
    background: "#F1F5F9", color: "#475569",
    border: "1px solid #CBD5E1",
  },
  kpiBox: {
    textAlign: "center", padding: "10px 8px",
    borderRadius: 8, background: "#F8FAFC",
    border: "1px solid #E2E8F0", minWidth: 100,
  },
  kpiVal: {
    fontSize: 20, fontWeight: 700, color: "#1E293B",
    fontFamily: MONO,
  },
  kpiLabel: {
    fontSize: 10, fontWeight: 600, color: "#64748B",
    marginTop: 2, textTransform: "uppercase",
  },
  th: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 6px", textAlign: "left",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    position: "sticky", top: 0, background: "#fff", zIndex: 1,
  },
  td: {
    fontSize: 12, padding: "7px 6px", color: "#334155",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    fontFamily: FONT,
  },
};

// ── Calcolo cicli (Weekend ven-lun, Midweek mar-gio) ────────────
function calcolaCiclo(data) {
  const giorno = data.getDay(); // 0=dom, 1=lun, ..., 5=ven, 6=sab
  let inizio, fine, tipo;

  if (giorno >= 2 && giorno <= 4) {
    // Siamo in Midweek (mar=2, mer=3, gio=4)
    tipo = "Midweek";
    inizio = new Date(data);
    inizio.setDate(data.getDate() - (giorno - 2)); // torna a martedì
    fine = new Date(inizio);
    fine.setDate(inizio.getDate() + 2); // giovedì
  } else {
    // Siamo in Weekend (ven=5, sab=6, dom=0, lun=1)
    tipo = "Weekend";
    inizio = new Date(data);
    if (giorno === 0) {
      inizio.setDate(data.getDate() - 2); // dom → ven
    } else if (giorno === 1) {
      inizio.setDate(data.getDate() - 3); // lun → ven
    } else if (giorno === 6) {
      inizio.setDate(data.getDate() - 1); // sab → ven
    }
    // giorno === 5 → già venerdì
    fine = new Date(inizio);
    fine.setDate(inizio.getDate() + 3); // lunedì
  }

  return { tipo, inizio, fine };
}

function calcolaCicloPrecedente(data) {
  const cicloCorrente = calcolaCiclo(data);
  // Il giorno prima dell'inizio del ciclo corrente cade nel ciclo precedente
  const giornoPrima = new Date(cicloCorrente.inizio);
  giornoPrima.setDate(giornoPrima.getDate() - 1);
  return calcolaCiclo(giornoPrima);
}

function fmtDataIT(d) {
  if (!d) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear());
  return `${dd}/${mm}/${yy}`;
}

function fmtDataGiorno(d) {
  if (!d) return "";
  const giorni = ["Domenica", "Lunedì", "Martedì", "Mercoledì",
                  "Giovedì", "Venerdì", "Sabato"];
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${giorni[d.getDay()]} ${dd}/${mm}`;
}

function toISODate(d) {
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

// Compatta la stringa mercato per contesti operativi (Monitor Live).
// Da "Punta 1 1X2 ore9 + Banca X 1X2 ore9" → "Punta 1 + Banca X"
// Da "Punta U2.5 O/U ore8"                  → "Punta U2.5"
// Da "Banca BTTS SI BTTS ore8"              → "Banca BTTS SI"
// Logica: per ogni segmento separato da "+", tieni "Punta|Banca" + il/i token che precedono
//         "1X2", "O/U" o "BTTS" (famiglia), poi scarta famiglia + timing.
//         Per BTTS la famiglia è anche segno (es. "BTTS SI"), quindi cerchiamo
//         l'ULTIMA occorrenza della famiglia nei token.
// Fallback: se la stringa non matcha il pattern atteso, ritorna il testo originale.
function formattaMercatoOperativo(mercato) {
  if (!mercato || typeof mercato !== "string") return mercato || "";
  const FAMIGLIE = new Set(["1X2", "O/U", "BTTS"]);
  const segmenti = mercato.split("+").map(s => s.trim()).filter(Boolean);
  const pulite = segmenti.map(seg => {
    const tokens = seg.split(/\s+/);
    if (tokens.length < 3) return seg; // non matcha pattern: lascia invariato
    // trova l'ULTIMA occorrenza della famiglia (per gestire BTTS: segno + famiglia)
    let idxFam = -1;
    for (let i = tokens.length - 1; i >= 0; i--) {
      if (FAMIGLIE.has(tokens[i])) { idxFam = i; break; }
    }
    if (idxFam < 1) return seg; // famiglia non trovata o in posizione invalida
    // tieni tutto ciò che sta prima della famiglia
    return tokens.slice(0, idxFam).join(" ");
  });
  return pulite.join(" + ");
}

// ── Dropdown multi-select (senza checkbox, sfondo evidenziato) ──
function DropdownCheckbox({ opzioni, selezionate, onChange, placeholder, labelMap }) {
  const [aperto, setAperto] = useState(false);
  const [hover, setHover] = useState(null);
  const ref = useRef(null);

  // Chiudi se click fuori
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAperto(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // opzioni selezionabili (esclude separatori)
  const opzioniValide = opzioni.filter(o => o !== "---");

  const toggle = (val) => {
    if (selezionate.includes(val)) {
      onChange(selezionate.filter(v => v !== val));
    } else {
      onChange([...selezionate, val]);
    }
  };

  const tutteSelezionate = opzioniValide.length > 0
    && selezionate.length === opzioniValide.length;
  const toggleTutte = () => {
    onChange(tutteSelezionate ? [] : [...opzioniValide]);
  };

  const getLabel = (val) => (labelMap && labelMap[val]) || val;

  const labelTesto = selezionate.length === 0
    ? (placeholder || "Tutte")
    : selezionate.length === opzioniValide.length
      ? "Tutte"
      : selezionate.length <= 2
        ? selezionate.map(v => getLabel(v)).join(", ")
        : `${selezionate.length} selezionate`;

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setAperto(!aperto)}
        style={{
          ...stili.select,
          minWidth: 180, cursor: "pointer",
          display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 6,
          background: "#fff", textAlign: "left",
        }}
      >
        <span style={{
          overflow: "hidden", textOverflow: "ellipsis",
          whiteSpace: "nowrap", flex: 1,
        }}>
          {labelTesto}
        </span>
        <span style={{ fontSize: 10, color: "#94A3B8" }}>
          {aperto ? "▲" : "▼"}
        </span>
      </button>

      {aperto && (
        <div style={{
          position: "absolute", top: "100%", left: 0,
          marginTop: 4, minWidth: 220, maxHeight: 280,
          overflowY: "auto", background: "#fff",
          border: "1px solid #CBD5E1", borderRadius: 8,
          boxShadow: "0 4px 16px rgba(0,0,0,0.10)", zIndex: 50,
          padding: "6px 0",
        }}>
          {/* Seleziona/Deseleziona tutte */}
          <div
            style={{
              padding: "6px 12px", cursor: "pointer", fontSize: 13,
              fontFamily: FONT, fontWeight: 600, color: "#2563EB",
              borderBottom: "1px solid #E2E8F0", marginBottom: 2,
              background: hover === "__tutte__" ? "#F0F4FF" : "transparent",
            }}
            onClick={toggleTutte}
            onMouseEnter={() => setHover("__tutte__")}
            onMouseLeave={() => setHover(null)}
          >
            {tutteSelezionate ? "Deseleziona tutte" : "Seleziona tutte"}
          </div>

          {opzioni.map((op, idx) =>
            op === "---" ? (
              <div key={`sep-${idx}`} style={{
                borderTop: "1px solid #E2E8F0",
                margin: "4px 0",
              }} />
            ) : (
              <div
                key={op}
                style={{
                  padding: "5px 12px", cursor: "pointer", fontSize: 13,
                  fontFamily: FONT, color: "#334155",
                  background: selezionate.includes(op)
                    ? "#DBEAFE"
                    : hover === op ? "#F0F4FF" : "transparent",
                  fontWeight: selezionate.includes(op) ? 600 : 400,
                }}
                onClick={() => toggle(op)}
                onMouseEnter={() => setHover(op)}
                onMouseLeave={() => setHover(null)}
              >
                {getLabel(op)}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}

// ── Dropdown selezione singola (stesso stile, no checkbox) ────
function DropdownSingle({ opzioni, selezionato, onChange, placeholder, labelMap,
                         voceSpeciale }) {
  const [aperto, setAperto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAperto(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const getLabel = (val) => {
    if (voceSpeciale && val === voceSpeciale.valore) return voceSpeciale.label;
    return (labelMap && labelMap[val]) || val;
  };

  const labelTesto = selezionato
    ? getLabel(selezionato)
    : (placeholder || "Tutte");

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setAperto(!aperto)}
        style={{
          ...stili.select,
          minWidth: 180, cursor: "pointer",
          display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 6,
          background: "#fff", textAlign: "left",
        }}
      >
        <span style={{
          overflow: "hidden", textOverflow: "ellipsis",
          whiteSpace: "nowrap", flex: 1,
        }}>
          {labelTesto}
        </span>
        <span style={{ fontSize: 10, color: "#94A3B8" }}>
          {aperto ? "▲" : "▼"}
        </span>
      </button>

      {aperto && (
        <div style={{
          position: "absolute", top: "100%", left: 0,
          marginTop: 4, minWidth: 220, maxHeight: 280,
          overflowY: "auto", background: "#fff",
          border: "1px solid #CBD5E1", borderRadius: 8,
          boxShadow: "0 4px 16px rgba(0,0,0,0.10)", zIndex: 50,
          padding: "6px 0",
        }}>
          {/* Opzione "Tutte" per deselezionare */}
          <div
            style={{
              padding: "6px 12px", cursor: "pointer", fontSize: 13,
              fontFamily: FONT, fontWeight: 600, color: "#2563EB",
              borderBottom: "1px solid #E2E8F0", marginBottom: 2,
              background: !selezionato ? "#F0F4FF" : "transparent",
            }}
            onClick={() => { onChange(""); setAperto(false); }}
          >
            {placeholder || "Tutte"}
          </div>

          {opzioni.map(op => (
            <div
              key={op}
              style={{
                padding: "5px 12px", cursor: "pointer", fontSize: 13,
                fontFamily: FONT, color: "#334155",
                background: selezionato === op ? "#F0F4FF" : "transparent",
                fontWeight: selezionato === op ? 600 : 400,
              }}
              onClick={() => { onChange(selezionato === op ? "" : op); setAperto(false); }}
            >
              {getLabel(op)}
            </div>
          ))}

          {/* D816 v219 — voce speciale staccata in fondo: non e' una strategia */}
          {voceSpeciale && (
            <div
              style={{
                padding: "6px 12px", cursor: "pointer", fontSize: 13,
                fontFamily: FONT, color: "#334155",
                borderTop: "1px solid #E2E8F0", marginTop: 4, paddingTop: 8,
                background: selezionato === voceSpeciale.valore
                  ? "#F0F4FF" : "transparent",
                fontWeight: selezionato === voceSpeciale.valore ? 600 : 400,
              }}
              onClick={() => {
                onChange(selezionato === voceSpeciale.valore
                  ? "" : voceSpeciale.valore);
                setAperto(false);
              }}
            >
              <div>{voceSpeciale.label}</div>
              {voceSpeciale.sottotitolo && (
                <div style={{
                  fontSize: 11, color: "#64748B", fontWeight: 400,
                  marginTop: 2,
                }}>
                  {voceSpeciale.sottotitolo}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}export default function MonitorLive({ onNavigate }) {
  // ── State ───────────────────────────────────────────────────
  const [selezioni, setSelezioni] = useState([]);
  const [riepilogo, setRiepilogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");

  // Filtri
  const [filtroStato, setFiltroStato] = useState([]);
  const [filtroStrategia, setFiltroStrategia] = useState("");
  const [filtroLega, setFiltroLega] = useState([]);
  const [periodoPreset, setPeriodoPreset] = useState("corrente");
  const [dataDA, setDataDA] = useState("");
  const [dataA, setDataA] = useState("");

  // Dati di supporto
  const [strategie, setStrategie] = useState([]);
  const [legheLista, setLegheLista] = useState([]);

  // Pipeline log
  const [pipelineLog, setPipelineLog] = useState([]);
  const [showLog, setShowLog] = useState(false);
  const [ultimoLog, setUltimoLog] = useState(null);
  const [nuoviDati, setNuoviDati] = useState(false);
  const ultimoLogRef = useRef(null);
  const [logPagina, setLogPagina] = useState(1);
  const [logHasMore, setLogHasMore] = useState(false);
  const LOG_PAGE_SIZE = 30;

  // Errori attivi pipeline
  const [erroriAttivi, setErroriAttivi] = useState([]);
  const [showErrori, setShowErrori] = useState(false);
  const [segnandoRisolto, setSegnandoRisolto] = useState(false);

  // TASK 17 Strato D — Stato attivita automatiche (banner Monitor Live, D404)
  const [statoAttivita, setStatoAttivita] = useState(null);

  // Cronologia — riga espansa
  const [logEspanso, setLogEspanso] = useState(null);

  const [showInfoCiclo, setShowInfoCiclo] = useState(false);

  // v102: Ricalcolo pending (post-it banner + popup dettagli)
  const [ricalcoloPending, setRicalcoloPending] = useState(null);
  const [showDettagliDiff, setShowDettagliDiff] = useState(false);
  const [ignorandoPending, setIgnorandoPending] = useState(false);

  // v103: Anteprima mail ripristino ciclo (popup Opzione C)
  const [showAnteprimaMail, setShowAnteprimaMail] = useState(false);
  const [anteprimeMail, setAnteprimeMail] = useState([]);
  const [caricandoAnteprima, setCaricandoAnteprima] = useState(false);
  const [inviandoMail, setInviandoMail] = useState(false);
  const [sezioniEspanse, setSezioniEspanse] = useState({});

  // v128 — Macro-area B: invio selezione al Diario
  // Mappa selezione_id → array invii precedenti nel Diario
  // (popolata via POST /diario/operazioni/conteggio-by-selezioni)
  const [conteggiDiario, setConteggiDiario] = useState({});
  // Selezione su cui è stato cliccato il pulsante 📓 (oggetto selezione)
  // quando esistono già invii precedenti → apre popup conferma Versione B
  const [confermaInvioSel, setConfermaInvioSel] = useState(null);
  // Oggetto precompila per FormOperazione (null = form chiuso)
  const [formPrecompila, setFormPrecompila] = useState(null);
  // v138 — Sequenza multi-mercato: selezione in corso di invio (per banner transizione)
  // null = non in sequenza; { selezione, prossimoIndice, prossimoLabel } = banner attivo
  const [bannerProssimoMercato, setBannerProssimoMercato] = useState(null);

  // ── Calcolo date da preset ciclo ──────────────────────────────
  const oggi = new Date();
  const cicloCorrente = calcolaCiclo(oggi);
  const cicloPrecedente = calcolaCicloPrecedente(oggi);

  // Date effettive in base al preset
  const dateEffettive = (() => {
    if (periodoPreset === "corrente") {
      return { da: toISODate(cicloCorrente.inizio), a: toISODate(cicloCorrente.fine) };
    } else if (periodoPreset === "precedente") {
      return { da: toISODate(cicloPrecedente.inizio), a: toISODate(cicloPrecedente.fine) };
    } else {
      return { da: dataDA, a: dataA };
    }
  })();

  // Label descrittiva del periodo
  const periodoLabel = (() => {
    if (periodoPreset === "corrente") {
      return `Ciclo ${cicloCorrente.tipo} — Da ${fmtDataGiorno(cicloCorrente.inizio)} a ${fmtDataGiorno(cicloCorrente.fine)}`;
    } else if (periodoPreset === "precedente") {
      return `Ciclo ${cicloPrecedente.tipo} — Da ${fmtDataGiorno(cicloPrecedente.inizio)} a ${fmtDataGiorno(cicloPrecedente.fine)}`;
    } else if (dataDA || dataA) {
      const da = dataDA ? fmtDataIT(new Date(dataDA + "T00:00:00")) : "...";
      const a = dataA ? fmtDataIT(new Date(dataA + "T00:00:00")) : "...";
      return `Periodo personalizzato — Dal ${da} al ${a}`;
    }
    return "";
  })();

  // ── Carica strategie e campionati all'avvio ─────────────────
  useEffect(() => {
    fetch(`${API}/strategie`).then(r => r.json())
      .then(d => { if (Array.isArray(d)) setStrategie(d); })
      .catch(() => {});
    fetch(`${API}/campionati`).then(r => r.json())
      .then(d => {
        if (Array.isArray(d)) setLegheLista(d.map(c => c.nome_bf || c.nome || String(c)));
      })
      .catch(() => {});
    fetch(`${API}/pipeline/log?limit=1`).then(r => r.json())
      .then(d => {
        if (Array.isArray(d) && d.length > 0) {
          setUltimoLog(d[0]);
          ultimoLogRef.current = d[0].eseguito_at || null;
        }
      })
      .catch(() => {});
    // Carica errori attivi
    fetch(`${API}/pipeline/errori-attivi`).then(r => r.json())
      .then(d => {
        const lista = d.errori || [];
        setErroriAttivi(lista);
        setShowErrori(lista.length > 0);
      })
      .catch(() => {});
    // v102: Carica ricalcolo pending (banner post-it)
    fetch(`${API}/pipeline/ricalcolo-pending`).then(r => r.json())
      .then(d => { if (d && d.pending) setRicalcoloPending(d.pending); })
      .catch(() => {});
    // TASK 17 Strato D — Carica stato attivita automatiche (banner D404)
    fetch(`${API}/pipeline/stato-attivita`).then(r => r.json())
      .then(d => { if (d) setStatoAttivita(d); })
      .catch(() => {});
  }, []);

  // TASK 17 Strato D — Polling stato attivita ogni 5 minuti
  useEffect(() => {
    const intervallo = setInterval(() => {
      fetch(`${API}/pipeline/stato-attivita`).then(r => r.json())
        .then(d => { if (d) setStatoAttivita(d); })
        .catch(() => {});
    }, 5 * 60 * 1000);
    return () => clearInterval(intervallo);
  }, []);

  // ── Check periodico nuovi dati (ogni 10 minuti) ───────────────
  useEffect(() => {
    const intervallo = setInterval(async () => {
      try {
        const resp = await fetch(`${API}/pipeline/log?limit=1`);
        const data = await resp.json();
        if (Array.isArray(data) && data.length > 0) {
          const nuovoTs = data[0].eseguito_at || null;
          if (nuovoTs && nuovoTs !== ultimoLogRef.current) {
            setNuoviDati(true);
          }
        }
      } catch {}
    }, 10 * 60 * 1000); // 10 minuti
    return () => clearInterval(intervallo);
  }, []);

  // ── Fetch selezioni ─────────────────────────────────────────
  const caricaSelezioni = useCallback(async () => {
    // Blocca fetch se personalizzato senza date
    if (periodoPreset === "personalizzato" && (!dataDA || !dataA)) {
      setSelezioni([]);
      setRiepilogo(null);
      return;
    }
    setLoading(true);
    setErrore("");
    try {
      // D816 v219 — la voce "Sistemi fuori strategia" non e' una strategia:
      // le sue partite non esistono a database e vengono calcolate al volo da
      // un endpoint dedicato. A filtro vuoto, invece, chiediamo al backend di
      // escludere quei sistemi: "Tutte" vale su tutte le strategie.
      const soloFuori = filtroStrategia === FUORI_STRATEGIA;

      const body = {};
      if (filtroStrategia && !soloFuori) body.strategia_id = filtroStrategia;
      if (!filtroStrategia) body.escludi_fuori_strategia = true;
      if (filtroStato.length > 0) body.stati = filtroStato;
      if (filtroLega.length > 0) body.lega = filtroLega;
      if (dateEffettive.da) body.data_da = dateEffettive.da;
      if (dateEffettive.a) body.data_a = dateEffettive.a;

      const url = soloFuori
        ? `${API}/selezioni/fuori-strategia`
        : `${API}/selezioni`;

      const resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!resp.ok) throw new Error(`Errore ${resp.status}`);
      const data = await resp.json();
      setSelezioni(data.selezioni || []);
      setRiepilogo(data.riepilogo || null);
    } catch (e) {
      setErrore(e.message);
      setSelezioni([]);
    } finally {
      setLoading(false);
    }
  }, [filtroStato, filtroStrategia, filtroLega, dateEffettive.da, dateEffettive.a, periodoPreset, dataDA, dataA]);

  // Carica all'avvio
  useEffect(() => { caricaSelezioni(); }, [caricaSelezioni]);

  // ── v128: Conteggio operazioni Diario per selezioni visibili ──
  // Chiamata batch unica ogni volta che cambia la lista delle selezioni.
  // Popola conteggiDiario = { selezione_id: [ {id, data_invio, bookmaker_nome, quota_effettiva}, ... ] }
  const caricaConteggiDiario = useCallback(async (sels) => {
    const ids = (sels || []).map(s => s.id).filter(Boolean);
    if (ids.length === 0) {
      setConteggiDiario({});
      return;
    }
    try {
      const resp = await fetch(`${API}/diario/operazioni/conteggio-by-selezioni`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ selezione_ids: ids }),
      });
      if (!resp.ok) return;
      const data = await resp.json();
      setConteggiDiario(data || {});
    } catch {
      // Errore silenzioso: non bloccante per l'esperienza utente
    }
  }, []);

  useEffect(() => {
    caricaConteggiDiario(selezioni);
  }, [selezioni, caricaConteggiDiario]);

  // Costruisce l'oggetto precompila a partire da una selezione del Monitor.
  // v138: accetta indiceMercato (default 0) → usa s.mercati[indiceMercato] se presente,
  // altrimenti fallback al comportamento legacy (campo mercato/tipo vuoti).
  // Lascia vuoti i campi operativi (bookmaker, quota effettiva, fee) che vanno
  // compilati dopo aver aperto il book.
  const buildPrecompila = (s, indiceMercato = 0) => {
    const merc = Array.isArray(s.mercati) && s.mercati[indiceMercato]
      ? s.mercati[indiceMercato]
      : null;
    return {
      selezione_id: s.id,
      data_partita: s.data,
      ora_partita: s.ora,
      casa: s.casa,
      trasferta: s.trasferta,
      competizione: s.lega,
      sistema_id: s.sistema_nome || s.sistema_id,
      // v138: se il backend ha pre-parsato il mercato → usa codice/tipo/quota dedicati;
      // altrimenti fallback legacy (quota generica della selezione, campo mercato vuoto)
      mercato: merc ? merc.codice_mercato : "",
      tipo_punta_banca: merc ? merc.tipo_punta_banca : "Punta",
      quota_teorica: merc ? merc.quota_teorica : s.quota,
    };
  };

  // v138 — Calcola l'indice del prossimo mercato da inviare al Diario per una selezione.
  // Confronta s.mercati con gli invii già esistenti (conteggiDiario) usando
  // codice_mercato + tipo_punta_banca come chiave. Ritorna:
  //   - indice del primo mercato non ancora inviato
  //   - null se tutti i mercati sono già stati inviati
  // Nota: a parità di codice+tipo, ne basta UNO già inviato per considerarlo coperto
  // (re-invio sullo stesso mercato è uno scenario diverso, gestito dal popup conferma).
  const calcolaProssimoIndiceMercato = (s) => {
    const mercati = Array.isArray(s.mercati) ? s.mercati : [];
    if (mercati.length === 0) return null;
    const invii = conteggiDiario[String(s.id)] || [];
    // Set delle chiavi "codice|tipo" già inviate
    const chiaviInviate = new Set();
    for (const inv of invii) {
      if (inv.mercato && inv.tipo_punta_banca) {
        chiaviInviate.add(`${inv.mercato}|${inv.tipo_punta_banca}`);
      }
    }
    for (let i = 0; i < mercati.length; i++) {
      const m = mercati[i];
      const k = `${m.codice_mercato}|${m.tipo_punta_banca}`;
      if (!chiaviInviate.has(k)) return i;
    }
    return null; // tutti già inviati
  };

  // Stati selezione per cui il pulsante 📓 è disabilitato (EC3 v128)
  const STATI_DIARIO_DISABILITATI = new Set([
    "Da Confermare", "Da Confermare Live",
    "NON Confermato", "NON Confermato Live",
    "Cancellato",
  ]);

  // Click sul pulsante 📓 della riga selezione (v138 — logica multi-mercato)
  const onClickInvioDiario = (s) => {
    const invii = conteggiDiario[String(s.id)] || [];

    if (invii.length > 0) {
      // Esistono invii precedenti (mono o multi-mercato) → popup riepilogativo.
      // Per multi-mercato il popup mostra anche il mercato di ogni operazione.
      // La logica "quale form aprire dopo" è in onConfermaInvioDiario.
      setConfermaInvioSel(s);
    } else {
      // Mai inviata → apre direttamente il form pre-compilato sul primo mercato
      setFormPrecompila(buildPrecompila(s, 0));
    }
  };

  // Conferma "Procedi" dal popup riepilogativo.
  // v138: per multi-mercato sceglie il primo mercato non ancora inviato;
  //       se tutti già inviati (o mono-mercato), riparte dal mercato 0.
  const onConfermaInvioDiario = () => {
    if (!confermaInvioSel) return;
    const s = confermaInvioSel;
    const mercati = Array.isArray(s.mercati) ? s.mercati : [];
    let idx = 0;
    if (mercati.length > 1) {
      const prossimo = calcolaProssimoIndiceMercato(s);
      if (prossimo !== null) idx = prossimo;
      // else: tutti già inviati → idx resta 0 (re-invio dal primo)
    }
    setFormPrecompila(buildPrecompila(s, idx));
    setConfermaInvioSel(null);
  };

  // Salvataggio nuova op da FormOperazione → ricarica i conteggi.
  // v138: dopo il refresh, se la selezione corrente ha ancora mercati da inviare,
  // mostra banner di transizione "Procedi con [prossimo mercato]?".
  const onSalvaFormDiario = async () => {
    // Memorizzo la selezione corrente PRIMA di chiudere il form
    const selCorrente = formPrecompila
      ? selezioni.find(x => x.id === formPrecompila.selezione_id)
      : null;
    setFormPrecompila(null);
    // Ricarico conteggi (così calcolaProssimoIndiceMercato vede l'invio appena fatto)
    await caricaConteggiDiario(selezioni);
    // Se siamo in sequenza multi-mercato → controllo se c'è un prossimo mercato
    if (selCorrente && Array.isArray(selCorrente.mercati) && selCorrente.mercati.length > 1) {
      // Nota: usiamo selCorrente fresca da `selezioni` (ha s.mercati aggiornati),
      // ma per il check serve conteggiDiario aggiornato. React garantisce che al prossimo
      // render lo stato sia fresco → calcolo qui sulla base delle informazioni note
      // (mercati di s) e degli invii FRESCHI tramite refetch sopra.
      // Workaround: piccolo helper inline che rilegge dallo stato corrente (chiusura).
      // → Usiamo un setTimeout 0 per garantire che setConteggiDiario sia stato applicato.
      setTimeout(() => {
        // calcolaProssimoIndiceMercato legge conteggiDiario dalla chiusura dello state
        // attuale del componente: dopo il setTimeout React ha già applicato setConteggiDiario.
        const idx = calcolaProssimoIndiceMercato(selCorrente);
        if (idx !== null && idx < selCorrente.mercati.length) {
          setBannerProssimoMercato({
            selezione: selCorrente,
            prossimoIndice: idx,
            prossimoLabel: selCorrente.mercati[idx].mercato_label || `Mercato ${idx + 1}`,
          });
        }
      }, 0);
    }
  };

  // v138 — Click "Continua" sul banner di transizione: apre form sul prossimo mercato
  const onContinuaProssimoMercato = () => {
    if (!bannerProssimoMercato) return;
    const { selezione, prossimoIndice } = bannerProssimoMercato;
    setBannerProssimoMercato(null);
    setFormPrecompila(buildPrecompila(selezione, prossimoIndice));
  };

  // v138 — Click "Più tardi" sul banner: chiude tutto, l'utente può sempre tornare
  const onPiuTardiProssimoMercato = () => {
    setBannerProssimoMercato(null);
  };

  // ── Aggiorna dopo notifica nuovi dati ─────────────────────────
  const aggiornaConNuoviDati = async () => {
    setNuoviDati(false);
    // Aggiorna ultimo log
    try {
      const resp = await fetch(`${API}/pipeline/log?limit=1`);
      const data = await resp.json();
      if (Array.isArray(data) && data.length > 0) {
        setUltimoLog(data[0]);
        ultimoLogRef.current = data[0].eseguito_at || null;
      }
    } catch {}
    // Ricarica selezioni
    caricaSelezioni();
  };

  // ── Carica pipeline log ─────────────────────────────────────
  const caricaLog = async (append = false) => {
    try {
      const offset = append ? pipelineLog.length : 0;
      const resp = await fetch(`${API}/pipeline/log?limit=${LOG_PAGE_SIZE + 1}&offset=${offset}`);
      const data = await resp.json();
      const logs = Array.isArray(data) ? data : [];
      const hasMore = logs.length > LOG_PAGE_SIZE;
      const logsPage = hasMore ? logs.slice(0, LOG_PAGE_SIZE) : logs;
      setLogHasMore(hasMore);
      if (append) {
        setPipelineLog(prev => [...prev, ...logsPage]);
      } else {
        setPipelineLog(logsPage);
        if (logsPage.length > 0) setUltimoLog(logsPage[0]);
      }
      setShowLog(true);
    } catch { if (!append) setPipelineLog([]); }
  };



  // ── Segna errori come risolti ───────────────────────────────
  const segnaRisolto = async () => {
    setSegnandoRisolto(true);
    try {
      await fetch(`${API}/pipeline/errori-attivi/segna-risolto`, { method: "POST" });
      // Ricarica errori reali dall'API invece di svuotare la lista localmente
      const r = await fetch(`${API}/pipeline/errori-attivi`);
      const data = await r.json();
      const lista = data.errori || [];
      setErroriAttivi(lista);
      setShowErrori(lista.length > 0);
    } catch {}
    setSegnandoRisolto(false);
  };

  // v102: Ignora pending (chiude il post-it senza inviare mail)
  const ignoraPending = async () => {
    if (!ricalcoloPending) return;
    setIgnorandoPending(true);
    try {
      await fetch(`${API}/pipeline/ricalcolo-pending/ignora`, { method: "POST" });
      setRicalcoloPending(null);
      setShowDettagliDiff(false);
    } catch {}
    setIgnorandoPending(false);
  };

  // v103: Apri popup anteprima mail ripristino ciclo
  const inviaMailAggiornamento = async () => {
    if (!ricalcoloPending || !ricalcoloPending.id) {
      alert("Nessun ricalcolo in attesa di invio mail.");
      return;
    }
    setCaricandoAnteprima(true);
    setShowAnteprimaMail(true);
    try {
      const res = await fetch(`${API}/pipeline/mail-ripristino-ciclo/anteprima`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pending_id: ricalcoloPending.id }),
      });
      const data = await res.json();
      const mail = Array.isArray(data?.mail) ? data.mail : [];
      setAnteprimeMail(mail);
      // Espande la prima strategia di default
      if (mail.length > 0) {
        setSezioniEspanse({ [mail[0].strategia_id]: true });
      } else {
        setSezioniEspanse({});
      }
    } catch (e) {
      setAnteprimeMail([]);
      alert("Errore nel caricamento anteprima mail.");
    }
    setCaricandoAnteprima(false);
  };

  // v103: Conferma e invia davvero le mail
  const confermaInvioMail = async () => {
    if (!ricalcoloPending || !ricalcoloPending.id) return;
    setInviandoMail(true);
    try {
      const res = await fetch(`${API}/pipeline/mail-ripristino-ciclo/invia`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pending_id: ricalcoloPending.id }),
      });
      const data = await res.json();
      if (data?.esito === "successo") {
        alert(`Inviate ${data.mail_inviate} mail.`);
        setShowAnteprimaMail(false);
        setShowDettagliDiff(false);
        setRicalcoloPending(null);
        setAnteprimeMail([]);
        setSezioniEspanse({});
      } else {
        const dett = data?.dettaglio || "errore sconosciuto";
        alert(`Invio non completato: ${dett}`);
      }
    } catch (e) {
      alert("Errore durante l'invio mail.");
    }
    setInviandoMail(false);
  };

  // ── Formattazione ───────────────────────────────────────────
  const fmtData = (d) => {
    if (!d) return "";
    try {
      const giorni = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
      const [y, m, dd] = d.split("-");
      const dt = new Date(parseInt(y), parseInt(m) - 1, parseInt(dd));
      return `${giorni[dt.getDay()]} ${dd}/${m}/${y}`;
    } catch { return d; }
  };

  const fmtPunti = (v) => {
    if (v === null || v === undefined) return "—";
    const n = parseFloat(v);
    if (isNaN(n)) return String(v);
    const s = n >= 0 ? "+" : "";
    return s + n.toFixed(2);
  };

  const fmtQuota = (v) => {
    if (v === null || v === undefined) return "N.A.";
    return parseFloat(v).toFixed(2);
  };

  // TASK 14 — Formatta le quote per la cella Quota del Monitor Live.
  // Sistemi single-mercato: ritorna la singola quota (comportamento invariato).
  // Sistemi multi-mercato (s.mercati con >=2 elementi): ritorna "X.XX / Y.YY"
  // con trattino "—" per quote_teorica mancanti (null/undefined).
  // Fallback (array assente o vuoto): usa s.quota come oggi.
  const fmtQuoteMonitor = (s) => {
    const mercati = Array.isArray(s.mercati) ? s.mercati : [];
    if (mercati.length === 0) {
      return fmtQuota(s.quota);
    }
    if (mercati.length === 1) {
      const q = mercati[0].quota_teorica;
      return fmtQuota(q);
    }
    return mercati.map(m => {
      const q = m.quota_teorica;
      if (q === null || q === undefined) return "—";
      return parseFloat(q).toFixed(2);
    }).join(" / ");
  };

  const fmtOra = (v) => {
    if (!v) return "";
    // Tronca "HH:MM:SS" a "HH:MM"
    const s = String(v);
    return s.length >= 5 ? s.substring(0, 5) : s;
  };

  // Converte timestamp DB (già in ora italiana, senza fuso orario) in oggetto Date locale.
  // Legge i componenti direttamente per evitare qualsiasi conversione UTC da parte del browser.
  const parseTimestampDB = (ts) => {
    if (!ts) return null;
    const s = String(ts);
    // Formato Supabase: "2026-03-20 08:15:41.060132"
    const [datePart, timePart] = s.split(" ");
    if (!datePart || !timePart) return new Date(s);
    const [y, mo, dd] = datePart.split("-").map(Number);
    const [hh, mm, ss] = timePart.split(":").map(Number);
    return new Date(y, mo - 1, dd, hh, mm, ss || 0);
  };

  // ── Render ──────────────────────────────────────────────────
  const oggiLabel = (() => {
    const giorni = ["Domenica", "Lunedì", "Martedì", "Mercoledì",
                    "Giovedì", "Venerdì", "Sabato"];
    const mesi = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio",
                  "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre",
                  "Novembre", "Dicembre"];
    const d = new Date();
    return `${giorni[d.getDay()]} ${d.getDate()} ${mesi[d.getMonth()]} ${d.getFullYear()}`;
  })();

  return (
    <div style={stili.pagina}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 16, marginBottom: 4 }}>
        <h1 style={{ ...stili.titolo, margin: 0 }}>📅 Monitor Live</h1>
        <span style={{ fontFamily: FONT, fontSize: 14, fontWeight: 500, color: "#64748B" }}>
          {oggiLabel}
        </span>
      </div>
      <p style={{ fontSize: 13, color: "#64748B", marginBottom: 18 }}>
        Stato del ciclo corrente, selezioni attive in mercato e anomalie operative.
      </p>

      {/* ── FILTRI ── */}
      <div style={{ ...stili.card, display: "flex", flexWrap: "wrap",
                    gap: 16, alignItems: "flex-end" }}>
        {/* Stato */}
        <div>
          <span style={stili.label}>Stato</span>
          <DropdownCheckbox
            opzioni={["Confermato", "In attesa", "Verifica pre-match",
                      "Non confermato", "Cancellato", "---", "Già disputate"]}
            selezionate={filtroStato}
            onChange={setFiltroStato}
            placeholder="Tutte"
            labelMap={STATO_LABEL_MAP}
          />
        </div>

        {/* Strategia */}
        <div>
          <span style={stili.label}>Strategia</span>
          <DropdownSingle
            opzioni={strategie.map(s => s.id)}
            selezionato={filtroStrategia}
            onChange={setFiltroStrategia}
            placeholder="Tutte"
            labelMap={Object.fromEntries(strategie.map(s => [s.id, s.nome]))}
            voceSpeciale={{
              valore: FUORI_STRATEGIA,
              label: "Sistemi fuori strategia",
              sottotitolo: "Elenco eventi di sistemi attivi senza strategia",
            }}
          />
        </div>

        {/* Lega (dropdown checkbox) */}
        <div>
          <span style={stili.label}>Lega</span>
          <DropdownCheckbox
            opzioni={legheLista}
            selezionate={filtroLega}
            onChange={setFiltroLega}
            placeholder="Tutte"
          />
        </div>

        {/* Periodo (preset) */}
        <div>
          <span style={stili.label}>Periodo</span>
          <select style={stili.select} value={periodoPreset}
                  onChange={e => setPeriodoPreset(e.target.value)}>
            <option value="corrente">Ciclo corrente</option>
            <option value="precedente">Ciclo precedente</option>
            <option value="personalizzato">Personalizzato</option>
          </select>
        </div>

        {/* Campi data (solo se personalizzato) */}
        {periodoPreset === "personalizzato" && (
          <>
            <div>
              <span style={stili.label}>Da</span>
              <input type="date" style={stili.input} value={dataDA}
                     onChange={e => setDataDA(e.target.value)} />
            </div>
            <div>
              <span style={stili.label}>A</span>
              <input type="date" style={stili.input} value={dataA}
                     onChange={e => setDataA(e.target.value)} />
            </div>
          </>
        )}

        {/* Pulsante Reset */}
        <button style={{ ...stili.btn, ...stili.btnSecondary }}
                onClick={() => {
                  setFiltroStato([]); setFiltroStrategia("");
                  setFiltroLega([]); setPeriodoPreset("corrente");
                  setDataDA(""); setDataA("");
                }}>
          Reset
        </button>
      </div>

      {/* ── BADGE FILTRI ATTIVI ── */}
      {(filtroStato.length > 0 || filtroStrategia || filtroLega.length > 0) && (
        <div style={{
          display: "flex", flexWrap: "wrap", gap: 6,
          padding: "0 4px", marginTop: -8, marginBottom: 10,
        }}>
          {filtroStato.map(st => (
            <span key={st} style={{
              display: "inline-flex", alignItems: "center", gap: 4,
              background: "#EEF2FF", color: "#4338CA", fontSize: 11,
              fontWeight: 600, fontFamily: FONT, padding: "3px 10px",
              borderRadius: 20, border: "1px solid #C7D2FE",
            }}>
              {STATO_LABEL_MAP[st] || st}
              <span style={{ cursor: "pointer", fontSize: 13, marginLeft: 2 }}
                    onClick={() => setFiltroStato(filtroStato.filter(v => v !== st))}>✕</span>
            </span>
          ))}
          {filtroStrategia && (
            <span style={{
              display: "inline-flex", alignItems: "center", gap: 4,
              background: "#FEF3C7", color: "#92400E", fontSize: 11,
              fontWeight: 600, fontFamily: FONT, padding: "3px 10px",
              borderRadius: 20, border: "1px solid #FDE68A",
            }}>
              {filtroStrategia === FUORI_STRATEGIA
                ? "Sistemi fuori strategia"
                : (strategie.find(s => s.id === filtroStrategia)?.nome || filtroStrategia)}
              <span style={{ cursor: "pointer", fontSize: 13, marginLeft: 2 }}
                    onClick={() => setFiltroStrategia("")}>✕</span>
            </span>
          )}
          {filtroLega.map(l => (
            <span key={l} style={{
              display: "inline-flex", alignItems: "center", gap: 4,
              background: "#ECFDF5", color: "#065F46", fontSize: 11,
              fontWeight: 600, fontFamily: FONT, padding: "3px 10px",
              borderRadius: 20, border: "1px solid #A7F3D0",
            }}>
              {l}
              <span style={{ cursor: "pointer", fontSize: 13, marginLeft: 2 }}
                    onClick={() => setFiltroLega(filtroLega.filter(v => v !== l))}>✕</span>
            </span>
          ))}
        </div>
      )}

      {/* ── MESSAGGIO DATE OBBLIGATORIE ── */}
      {periodoPreset === "personalizzato" && (!dataDA || !dataA) && (
        <div style={{
          fontFamily: FONT, fontSize: 12, color: "#F59E0B",
          padding: "0 4px", marginTop: -8, marginBottom: 12,
          display: "flex", alignItems: "center", gap: 4,
        }}>
          ⚠️ Seleziona le date Da e A per filtrare
        </div>
      )}

      {/* ── INDICATORE PERIODO ── */}
      {periodoLabel && (
        <div style={{ padding: "0 4px", marginTop: -8, marginBottom: 12 }}>
          <div style={{
            fontFamily: FONT, fontSize: 13, fontWeight: 600,
            color: "#475569", display: "flex", alignItems: "center", gap: 6,
          }}>
            <span style={{ fontSize: 14 }}>📅</span>
            {periodoLabel}
            {(periodoPreset === "corrente" || periodoPreset === "precedente") && (
              <span
                onClick={() => setShowInfoCiclo(!showInfoCiclo)}
                style={{
                  fontSize: 14, cursor: "pointer", marginLeft: 2,
                  opacity: 0.7, transition: "opacity 0.15s",
                }}
                onMouseEnter={e => e.target.style.opacity = 1}
                onMouseLeave={e => e.target.style.opacity = 0.7}
              >ℹ️</span>
            )}
          </div>
          {showInfoCiclo && (
            <div style={{
              fontFamily: FONT, fontSize: 12, color: "#475569",
              background: "#F0F7FF", border: "1px solid #BFDBFE",
              borderRadius: 8, padding: "10px 14px", marginTop: 6,
              lineHeight: 1.7,
            }}>
              <div style={{ fontWeight: 700, marginBottom: 4, color: "#1E40AF" }}>
                Come funzionano i cicli
              </div>
              <div>Le partite sono raggruppate in cicli di 3-4 giorni:</div>
              <div style={{ paddingLeft: 8 }}>
                — <strong>Weekend</strong>: da venerdì a lunedì
              </div>
              <div style={{ paddingLeft: 8 }}>
                — <strong>Midweek</strong>: da martedì a giovedì
              </div>
              <div style={{ marginTop: 4 }}>
                Ogni martedì e venerdì inizia un nuovo ciclo con nuove selezioni.
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── ERRORE ── */}
      {errore && (
        <div style={{ ...stili.card, background: "#FFF5F5",
                      color: "#C53030", fontSize: 13 }}>
          Errore: {errore}
        </div>
      )}

      {/* ── KPI RIEPILOGO ── */}
      {riepilogo && (() => {
        // Ricalcolo KPI con nuova logica (Cancellate separate da Non Confermate)
        const kpi = { totale: selezioni.length, confermate: 0, da_confermare: 0,
                      non_confermate: 0, cancellate: 0, in_attesa_ris: 0, pl: 0 };
        for (const s of selezioni) {
          const st = s.stato || "";
          if (st === "-" || st === "Confermato" || st === "Confermato Live") {
            kpi.confermate++;
            if (!s.risultato) kpi.in_attesa_ris++;
          } else if (st === "Da Confermare" || st === "Da Confermare Live") {
            kpi.da_confermare++;
          } else if (st === "NON Confermato" || st === "NON Confermato Live") {
            kpi.non_confermate++;
          } else if (st === "Cancellato") {
            kpi.cancellate++;
          }
          if (s.punti != null) { try { kpi.pl += parseFloat(s.punti); } catch {} }
        }
        kpi.pl = Math.round(kpi.pl * 100) / 100;
        return (
        <div style={{ ...stili.card, display: "flex", gap: 12,
                      flexWrap: "wrap" }}>
          <div style={stili.kpiBox}>
            <div style={stili.kpiVal}>{kpi.totale}</div>
            <div style={stili.kpiLabel}>Totale</div>
          </div>
          <div style={{ ...stili.kpiBox, borderColor: "#C8E6C9" }}>
            <div style={{ ...stili.kpiVal, color: "#2E7D32" }}>
              {kpi.confermate}
            </div>
            <div style={stili.kpiLabel}>Confermate</div>
          </div>
          <div style={{ ...stili.kpiBox, borderColor: "#FFF9C4" }}>
            <div style={{ ...stili.kpiVal, color: "#F57F17" }}>
              {kpi.da_confermare}
            </div>
            <div style={stili.kpiLabel}>Da confermare</div>
          </div>
          <div style={{ ...stili.kpiBox, borderColor: "#FFCDD2" }}>
            <div style={{ ...stili.kpiVal, color: "#C62828" }}>
              {kpi.non_confermate}
            </div>
            <div style={stili.kpiLabel}>Non confermate</div>
          </div>
          {kpi.cancellate > 0 && (
          <div style={{ ...stili.kpiBox, borderColor: "#E0E0E0" }}>
            <div style={{ ...stili.kpiVal, color: "#757575" }}>
              {kpi.cancellate}
            </div>
            <div style={stili.kpiLabel}>Cancellate</div>
          </div>
          )}
          <div style={stili.kpiBox}>
            <div style={stili.kpiVal}>{kpi.in_attesa_ris}</div>
            <div style={stili.kpiLabel}>In attesa di risultato</div>
          </div>
          <div style={{ ...stili.kpiBox,
                        borderColor: kpi.pl >= 0 ? "#C8E6C9" : "#FFCDD2" }}>
            <div style={{ ...stili.kpiVal, fontFamily: MONO,
                          color: kpi.pl >= 0 ? "#2E7D32" : "#C62828" }}>
              {kpi.pl >= 0 ? "+" : ""}{kpi.pl.toFixed(2)}
            </div>
            {/* D816 v219 — nella vista dei sistemi fuori strategia il numero e'
                corretto ma non e' denaro: quei sistemi non sono operativi.
                L'etichetta lo dichiara, invece di lasciarlo dedurre. */}
            <div style={stili.kpiLabel}
                 title={filtroStrategia === FUORI_STRATEGIA
                        ? "Risultato che questi sistemi avrebbero prodotto se fossero operativi"
                        : ""}>
              {filtroStrategia === FUORI_STRATEGIA
                ? "P/L Parziale (teorico)"
                : "P/L Parziale"}
            </div>
          </div>
        </div>
        );
      })()}

      {/* ── BANNER NUOVI DATI ── */}
      {nuoviDati && (
        <div
          onClick={aggiornaConNuoviDati}
          style={{
            fontFamily: FONT, fontSize: 13, fontWeight: 600,
            color: "#1D4ED8", background: "#EFF6FF",
            border: "1px solid #BFDBFE", borderRadius: 8,
            padding: "10px 16px", marginBottom: 8,
            display: "flex", alignItems: "center", gap: 8,
            cursor: "pointer",
          }}
        >
          <span style={{ fontSize: 16 }}>🔄</span>
          Nuovi dati disponibili — Clicca per aggiornare
        </div>
      )}

      {/* ── TASK 17 Strato D — BANNER STATO ATTIVITÀ AUTOMATICHE (D404, D405, D406) ── */}
      {statoAttivita && (() => {
        const stato = statoAttivita.stato_aggregato;
        const inattive = Array.isArray(statoAttivita.inattive) ? statoAttivita.inattive : [];
        const ultimoCtrl = statoAttivita.ultimo_controllo;
        const tooltipStato = "Controllo settimanale aggregato delle attività automatiche (le pipeline di import, ricalcolo e invio mail). Eseguito ogni domenica alle 5:00 dal vigile mattutino. Verifica che ciascuna abbia girato negli ultimi 8 giorni. Diverso dal banner 'Errori recenti' sotto, che mostra invece errori puntuali in tempo reale.";

        let bgColor = "#F0FDF4", borderColor = "#BBF7D0", textColor = "#15803D", icon = "🟢", testo;
        if (stato === "in_attesa") {
          bgColor = "#F1F5F9"; borderColor = "#CBD5E1"; textColor = "#475569"; icon = "⏳";
          testo = "Primo controllo non ancora eseguito (atteso prossima domenica alle 5:00)";
        } else if (stato === "warning" || inattive.length > 0) {
          bgColor = "#FFFBEB"; borderColor = "#FCD34D"; textColor = "#92400E"; icon = "⚠️";
          const nomi = inattive.map(i => i.label || i.tipo_log).join(", ");
          testo = `${inattive.length} inattive: ${nomi}`;
        } else {
          testo = "Tutte attive";
        }

        let suffissoData = "";
        if (ultimoCtrl) {
          try {
            const d = new Date(ultimoCtrl);
            const gg = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const aa = d.getFullYear();
            const giorni = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];
            suffissoData = ` (ultimo controllo: ${giorni[d.getDay()]} ${gg}/${mm}/${aa})`;
          } catch { suffissoData = ""; }
        }

        return (
          <div
            title={tooltipStato}
            style={{
              display: "flex", alignItems: "center", gap: 8,
              background: bgColor, border: `1px solid ${borderColor}`,
              borderRadius: 10, padding: "8px 16px", marginBottom: 10,
              fontFamily: FONT, fontSize: 13, color: textColor,
              cursor: "help",
            }}
          >
            <span style={{ fontSize: 14 }}>{icon}</span>
            <span style={{ fontWeight: 600 }}>Attività automatiche</span>
            <span style={{ opacity: 0.7 }}>·</span>
            <span>{testo}{suffissoData}</span>
          </div>
        );
      })()}

      {/* ── ERRORI IN EVIDENZA ── */}
      {erroriAttivi.length === 0 ? (
        ricalcoloPending ? (
          // v102: Banner pending ricalcolo (priorità minore degli errori)
          <div style={{
            background: "#FFFBEB", border: "1px solid #FCD34D",
            borderRadius: 10, padding: "12px 16px", marginBottom: 16,
            fontFamily: FONT,
          }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 10,
              flexWrap: "wrap", marginBottom: 6,
            }}>
              <span style={{ fontSize: 16 }}>⚠️</span>
              <span style={{ fontSize: 14, fontWeight: 700, color: "#92400E" }}>
                Ricalcolo completato — {
                  (ricalcoloPending.num_nuove || 0) +
                  (ricalcoloPending.num_eliminate || 0) +
                  (ricalcoloPending.num_modificate || 0)
                } variazioni rilevate
              </span>
            </div>
            <div style={{
              fontSize: 12, color: "#78350F", marginBottom: 10,
              paddingLeft: 26,
            }}>
              {ricalcoloPending.num_nuove || 0} nuovi ingressi ·
              {" "}{ricalcoloPending.num_eliminate || 0} eliminati ·
              {" "}{ricalcoloPending.num_modificate || 0} modificati
              {ricalcoloPending.diff_json && Array.isArray(ricalcoloPending.diff_json.strategie_impattate) && ricalcoloPending.diff_json.strategie_impattate.length > 0 && (
                <> · Strategie impattate: {ricalcoloPending.diff_json.strategie_impattate.map(s => s.nome).join(", ")}</>
              )}
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", paddingLeft: 26 }}>
              <button
                style={{ ...stili.btn, ...stili.btnSecondary, fontSize: 12 }}
                onClick={() => setShowDettagliDiff(true)}
              >
                📋 Vedi dettagli
              </button>
              <button
                style={{ ...stili.btn, ...stili.btnPrimary, fontSize: 12 }}
                onClick={inviaMailAggiornamento}
              >
                📧 Invia mail
              </button>
              <button
                style={{ ...stili.btn, ...stili.btnSecondary, fontSize: 12 }}
                onClick={ignoraPending}
                disabled={ignorandoPending}
              >
                {ignorandoPending ? "Ignorando…" : "✓ Ignora"}
              </button>
            </div>
          </div>
        ) : (
          <div
            title="Errori puntuali in tempo reale rilevati durante l'esecuzione delle pipeline (quote mancanti, risultati mancanti, anomalie). Distinto dal banner 'Attività automatiche' sopra, che mostra invece il controllo settimanale aggregato."
            style={{
              display: "flex", alignItems: "center", gap: 8,
              background: "#F0FDF4", border: "1px solid #BBF7D0",
              borderRadius: 10, padding: "10px 16px", marginBottom: 16,
              fontFamily: FONT, fontSize: 13, fontWeight: 600, color: "#15803D",
              cursor: "help",
            }}>
            ✅ Errori recenti — Nessuno
          </div>
        )
      ) : (
        <div
          title="Errori puntuali in tempo reale rilevati durante l'esecuzione delle pipeline (quote mancanti, risultati mancanti, anomalie). Distinto dal banner 'Attività automatiche' sopra, che mostra invece il controllo settimanale aggregato."
          style={{
            background: "#FFF7F7", border: "1px solid #FCA5A5",
            borderRadius: 10, marginBottom: 16, overflow: "hidden",
          }}>
          {/* Header collassabile */}
          <div
            onClick={() => setShowErrori(!showErrori)}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "12px 16px", cursor: "pointer",
              borderBottom: showErrori ? "1px solid #FCA5A5" : "none",
            }}
          >
            <span style={{ fontFamily: FONT, fontSize: 14, fontWeight: 700, color: "#991B1B", display: "flex", alignItems: "center", gap: 8 }}>
              ⚠️ Errori recenti
              <span style={{
                background: "#FEE2E2", color: "#991B1B", fontSize: 11,
                fontWeight: 700, padding: "1px 8px", borderRadius: 10,
              }}>
                {erroriAttivi.reduce((acc, g) => acc + g.count, 0)}
              </span>
            </span>
            <span style={{ fontSize: 12, color: "#B91C1C", fontFamily: FONT }}>
              {showErrori ? "▲ Chiudi" : "▼ Espandi"}
            </span>
          </div>

          {showErrori && (
            <div style={{ padding: "14px 16px" }}>
              {/* Lista gruppi errori */}
              {erroriAttivi.map((gruppo, gi) => {
                const TIPI_REALTIME = ["quota_mancante", "quota_bassa", "risultato_ht_mancante", "risultato_ft_mancante"];
                const isRealtime = TIPI_REALTIME.includes(gruppo.tipo);
                // v194 (D653): anche la squadra simile si risolve in Interventi su DB,
                // con la sezione "Correggi il nome di una squadra". Prima mostrava solo
                // "Segna come risolto", che chiude l'avviso senza aver corretto nulla.
                const haRimando = isRealtime || gruppo.tipo === "squadra_simile";
                return (
                  <div key={gi} style={{ marginBottom: 14 }}>
                    <div style={{ fontFamily: FONT, fontSize: 13, fontWeight: 700, color: "#991B1B", marginBottom: 6 }}>
                      🔴 <strong>{gruppo.count}</strong> {gruppo.label}
                    </div>
                    {/* Dettagli partite (se presenti) */}
                    {gruppo.dettagli && gruppo.dettagli.some(d => d) && (
                      <div style={{
                        background: "#fff", border: "1px solid #FCA5A5",
                        borderRadius: 6, overflow: "hidden", marginBottom: 6,
                      }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, fontFamily: FONT }}>
                          <thead>
                            <tr>
                              {gruppo.tipo === "squadra_simile" ? (
                                <th style={{ padding: "5px 10px", background: "#FFE4E4", borderBottom: "1px solid #FCA5A5", textAlign: "left", fontWeight: 700, color: "#7F1D1D", fontSize: 11 }}>Segnalazione</th>
                              ) : (
                                <>
                                  <th style={{ padding: "5px 10px", background: "#FFE4E4", borderBottom: "1px solid #FCA5A5", textAlign: "left", fontWeight: 700, color: "#7F1D1D", fontSize: 11 }}>Data</th>
                                  <th style={{ padding: "5px 10px", background: "#FFE4E4", borderBottom: "1px solid #FCA5A5", textAlign: "left", fontWeight: 700, color: "#7F1D1D", fontSize: 11 }}>Partita</th>
                                </>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {(() => {
                              // v208: la segnalazione "squadra simile" non descrive una partita
                              // ma un nome creato. Riga unica, testo integrale, nessun dedup
                              // (il dedup per campionato nascondeva la seconda squadra sospetta).
                              if (gruppo.tipo === "squadra_simile") {
                                return gruppo.dettagli.filter(d => d).map((det, di) => (
                                  <tr key={di} style={{ background: di % 2 === 0 ? "#fff" : "#FFF5F5" }}>
                                    <td style={{ padding: "4px 10px", borderBottom: "1px solid #FEE2E2", color: "#374151", whiteSpace: "pre-wrap" }}>{det}</td>
                                  </tr>
                                ));
                              }
                              const seen = new Set();
                              return gruppo.dettagli.filter(d => d).map((det, di) => {
                                const chiave = det.split(":")[0].split("(")[0].trim();
                                if (!chiave || seen.has(chiave)) return null;
                                seen.add(chiave);
                                const parti = chiave.split(" ");
                                const dataRaw = parti[0] || "";
                                const squadre = parti.slice(1).join(" ");
                                let dataFmt = dataRaw;
                                try {
                                  const [y, m, d2] = dataRaw.split("-");
                                  dataFmt = `${d2}/${m}/${y}`;
                                } catch {}
                                return (
                                  <tr key={di} style={{ background: di % 2 === 0 ? "#fff" : "#FFF5F5" }}>
                                    <td style={{ padding: "4px 10px", borderBottom: "1px solid #FEE2E2", color: "#374151" }}>{dataFmt}</td>
                                    <td style={{ padding: "4px 10px", borderBottom: "1px solid #FEE2E2", color: "#374151" }}>{squadre}</td>
                                  </tr>
                                );
                              });
                            })()}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {/* Pulsanti azione per gruppo */}
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                      {haRimando && (
                        <button
                          onClick={() => onNavigate && onNavigate("interventi-db")}
                          style={{ ...stili.btn, background: "#FEE2E2", color: "#991B1B", border: "1px solid #FCA5A5", fontSize: 12, padding: "5px 12px" }}
                        >
                          Vai a Interventi su DB →
                        </button>
                      )}
                      {!isRealtime && (
                        <>
                          <button
                            onClick={segnaRisolto}
                            disabled={segnandoRisolto}
                            style={{ ...stili.btn, background: "#DC2626", color: "#fff", fontSize: 12, padding: "5px 12px", opacity: segnandoRisolto ? 0.6 : 1 }}
                          >
                            {segnandoRisolto ? "Attendere..." : "✓ Segna come risolto"}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* ── TABELLA SELEZIONI ── */}
      <div style={{ ...stili.card, padding: 0, overflow: "hidden" }}>
        <div style={{ overflowX: "auto", maxHeight: 520 }}>
          <table style={{ width: "100%", borderCollapse: "collapse",
                          fontSize: 12, tableLayout: "fixed" }}>
            {/*
              Larghezze colonne tabella selezioni Monitor Live:
              Data 10% | Ora 4% | Lega 9% | Casa 9% | Trasferta 9% | Sistema 9% |
              Mercato 8.5% | Quota 4.5% | Stato 9% | Dettaglio 11% | Risultato 5% |
              Punti 5% | Mail 3.5% | Diario 4% (v128). Totale = 100%.
            */}
            <colgroup>
              <col style={{ width: "10%" }} />
              <col style={{ width: "4%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "8.5%" }} />
              <col style={{ width: "4.5%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "5%" }} />
              <col style={{ width: "5%" }} />
              <col style={{ width: "3.5%" }} />
              <col style={{ width: "4%" }} />
            </colgroup>
            <thead>
              <tr>
                {[
                  { label: "Data" },
                  { label: "Ora" },
                  { label: "Lega" },
                  { label: "Casa" },
                  { label: "Trasferta" },
                  { label: "Sistema" },
                  { label: "Mercato" },
                  { label: "Quota" },
                  { label: "Stato" },
                  { label: "Dettaglio condizioni" },
                  { label: "Risultato", align: "center" },
                  { label: "Punti" },
                  { label: "Mail", align: "center" },
                  { label: "Diario", align: "center" },
                ].map(h => (
                  <th key={h.label}
                      style={h.align
                        ? { ...stili.th, textAlign: h.align }
                        : stili.th}>
                    {h.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {selezioni.length === 0 && !loading ? (
                <tr>
                  <td colSpan={14} style={{ ...stili.td,
                       textAlign: "center", color: "#475569",
                       padding: 48, fontSize: 15, fontWeight: 600 }}>
                    {periodoPreset === "personalizzato" && (!dataDA || !dataA)
                      ? ""
                      : filtroStrategia === FUORI_STRATEGIA
                      /* D816 v219 — questi sistemi non producono ingressi a
                         mercato per definizione: il messaggio standard sarebbe
                         falso, e contraddirebbe le strategie che ne hanno. */
                      ? "Nessuna partita intercettata dai sistemi fuori strategia in questo ciclo"
                      : "🛑 Nessun ingresso a mercato previsto per questo ciclo"}
                  </td>
                </tr>
              ) : (
                selezioni.map((s, i) => {
                  const sc = STATO_COLORI[s.stato] || STATO_COLORI["-"];
                  const mi = MAIL_ICONE[s.mail_stato] || MAIL_ICONE["Da Inviare"];
                  const puntiColor = s.punti !== null && s.punti !== undefined
                    ? (parseFloat(s.punti) >= 0 ? "#2E7D32" : "#C62828")
                    : "#94A3B8";

                  return (
                    <tr key={s.id || i}
                        style={{ background: i % 2 === 0
                                 ? "#fff" : "#FAFBFC" }}>
                      <td style={stili.td}>{fmtData(s.data)}</td>
                      <td style={stili.td}>{fmtOra(s.ora)}</td>
                      <td style={{ ...stili.td, maxWidth: 120,
                                   overflow: "hidden",
                                   textOverflow: "ellipsis" }}>
                        {s.lega}
                      </td>
                      <td style={{ ...stili.td, fontWeight: 600 }}>
                        {s.casa}
                      </td>
                      <td style={{ ...stili.td, fontWeight: 600 }}>
                        {s.trasferta}
                      </td>
                      <td style={{ ...stili.td, fontSize: 11,
                                   color: "#6366F1" }}>
                        {s.sistema_nome}
                      </td>
                      <td style={{ ...stili.td, fontSize: 11 }}>
                        {formattaMercatoOperativo(s.mercato)}
                      </td>
                      <td style={{ ...stili.td, fontFamily: MONO }}>
                        {fmtQuoteMonitor(s)}
                      </td>
                      <td style={stili.td} title={sc.tip || ""}>
                        <span style={{
                          background: sc.bg, color: sc.color,
                          padding: "2px 8px", borderRadius: 4,
                          fontSize: 11, fontWeight: 600,
                          whiteSpace: "nowrap",
                          cursor: sc.tip ? "help" : "default",
                        }}>
                          {sc.label}
                        </span>
                      </td>
                      <td style={{ ...stili.td, fontSize: 11,
                                   color: "#78909C", maxWidth: 180,
                                   overflow: "hidden",
                                   textOverflow: "ellipsis" }}
                         title={[s.preselezione, s.condizioni_5mko]
                                .filter(Boolean).join(" | ") || ""}>
                        {[s.preselezione, s.condizioni_5mko]
                          .filter(Boolean).join(" | ") || "—"}
                      </td>
                      <td style={{ ...stili.td, fontFamily: MONO,
                                   fontWeight: 700, textAlign: "center" }}>
                        {s.risultato || "—"}
                      </td>
                      <td style={{ ...stili.td, fontFamily: MONO,
                                   fontWeight: 600,
                                   color: puntiColor }}>
                        {s.punti !== null && s.punti !== undefined
                          ? fmtPunti(s.punti)
                          : (s.risultato ? "—" : "In Corso")}
                      </td>
                      <td style={{ ...stili.td, textAlign: "center" }}
                          title={s.calcolata
                                 ? "Nessuna mail: il sistema non è in una strategia"
                                 : mi.tip + (s.mail_data
                                    ? ` (${fmtData(s.mail_data)})` : "")}>
                        {s.calcolata ? (
                          <span style={{ color: "#CBD5E1", fontSize: 16 }}>—</span>
                        ) : (
                          <span style={{ color: mi.color, fontSize: 16 }}>
                            {mi.icon}
                          </span>
                        )}
                      </td>
                      {/* v128 — colonna Diario */}
                      <td style={{ ...stili.td, textAlign: "center" }}>
                        {(() => {
                          const disabilitato = STATI_DIARIO_DISABILITATI.has(s.stato)
                            || !!s.calcolata;
                          const invii = conteggiDiario[String(s.id)] || [];
                          const giaInviata = invii.length > 0;
                          const icon = giaInviata ? "✅" : "📓";
                          const tip = s.calcolata
                            ? "I sistemi fuori strategia non si inviano al Diario"
                            : disabilitato
                            ? "Non disponibile per questo stato"
                            : (giaInviata
                                ? `Già inviata ${invii.length} ${invii.length === 1 ? "volta" : "volte"} — clicca per rivederla o reinviarla`
                                : "Invia al Diario");
                          return (
                            <span
                              role={disabilitato ? undefined : "button"}
                              onClick={disabilitato ? undefined : () => onClickInvioDiario(s)}
                              title={tip}
                              style={{
                                fontSize: 16,
                                cursor: disabilitato ? "not-allowed" : "pointer",
                                opacity: disabilitato ? 0.3 : 1,
                                userSelect: "none",
                              }}
                            >
                              {icon}
                            </span>
                          );
                        })()}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── CRONOLOGIA OPERAZIONI (riga separata) ── */}
      <div style={{ ...stili.card, display: "flex", alignItems: "center" }}>
        <button style={{ ...stili.btn, ...stili.btnSecondary }}
                onClick={() => { if (showLog) setShowLog(false); else caricaLog(); }}>
          {showLog ? "▲ Chiudi cronologia" : "📋 Cronologia operazioni"}
        </button>
      </div>

      {/* ── CRONOLOGIA (tabella raggruppata per giorno, se aperta) ── */}
      {showLog && (() => {
        // Raggruppamento per giorno
        const oggiStr = new Date().toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
        const ieriDate = new Date(); ieriDate.setDate(ieriDate.getDate() - 1);
        const ieriStr = ieriDate.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });

        const gruppi = [];
        let currentGruppo = null;
        for (const log of pipelineLog) {
          let giornoLabel = "";
          if (log.eseguito_at) {
            const dt = parseTimestampDB(log.eseguito_at);
            const dtStr = dt.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
            if (dtStr === oggiStr) {
              giornoLabel = "Oggi";
            } else if (dtStr === ieriStr) {
              giornoLabel = "Ieri";
            } else {
              const giorni = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
              giornoLabel = `${giorni[dt.getDay()]} ${dtStr}`;
            }
          } else {
            giornoLabel = "Data sconosciuta";
          }
          if (!currentGruppo || currentGruppo.label !== giornoLabel) {
            currentGruppo = { label: giornoLabel, logs: [] };
            gruppi.push(currentGruppo);
          }
          currentGruppo.logs.push(log);
        }

        return (
        <div style={{ ...stili.card, padding: 0, overflow: "hidden" }}>
          <div style={{ display: "flex", justifyContent: "space-between",
                        alignItems: "center", padding: "12px 16px",
                        borderBottom: "1px solid #E2E8F0" }}>
            <span style={{ fontSize: 14, fontWeight: 700,
                           color: "#1E293B" }}>
              Cronologia operazioni
            </span>
            <button style={{ ...stili.btn, ...stili.btnSecondary,
                             padding: "4px 10px", fontSize: 11 }}
                    onClick={() => setShowLog(false)}>
              Chiudi
            </button>
          </div>
          {/* Banner informativo ora legale/solare */}
          <div style={{
            padding: "10px 16px", fontSize: 11, lineHeight: 1.5,
            color: "#64748B", background: "#F8FAFC",
            borderBottom: "1px solid #E2E8F0",
          }}>
            ℹ️ Gli orari mostrati sono in ora italiana. Gli automatismi
            sono impostati in ora solare (partono sempre allo stesso
            orario). Quindi, durante il periodo in cui vige l'ora legale
            (da fine marzo a fine ottobre), un'operazione visualizzata
            come effettuata alle ore 7 è stata effettuata alle ore 6
            effettive.
          </div>
          <div style={{ overflowX: "auto", maxHeight: 420 }}>
            {pipelineLog.length === 0 ? (
              <div style={{ textAlign: "center", color: "#94A3B8",
                            padding: 32, fontSize: 13 }}>
                Nessun log disponibile
              </div>
            ) : (
              gruppi.map((gruppo, gi) => (
                <div key={gi}>
                  {/* Intestazione giorno */}
                  <div style={{
                    padding: "8px 16px", fontSize: 11, fontWeight: 700,
                    color: "#64748B", background: "#F1F5F9",
                    borderTop: gi > 0 ? "1px solid #E2E8F0" : "none",
                    borderBottom: "1px solid #E2E8F0",
                    textTransform: "uppercase", letterSpacing: "0.5px",
                    fontFamily: FONT,
                  }}>
                    {gruppo.label}
                  </div>
                  {/* Righe del giorno */}
                  {gruppo.logs.map((log, li) => {
                    const tipoInfo = getTipoInfo(log.tipo);
                    const isErrore = log.esito === "errore";
                    const isNotificaErrori = log.tipo === "notifica_errori" && log.esito === "successo";
                    const logKey = log.id || `${gi}-${li}`;
                    const isEspanso = logEspanso === logKey;
                    return (
                      <div key={logKey}>
                        <div
                          onClick={() => setLogEspanso(isEspanso ? null : logKey)}
                          style={{
                            display: "flex", alignItems: "center", gap: 10,
                            padding: "8px 16px",
                            background: isEspanso ? "#F0F7FF" : li % 2 === 0 ? "#fff" : "#FAFBFC",
                            borderBottom: "1px solid #F1F5F9",
                            fontSize: 12, fontFamily: FONT,
                            cursor: "pointer",
                          }}>
                          {/* Ora */}
                          <span style={{ width: 44, flexShrink: 0, color: "#64748B",
                                         fontFamily: MONO, fontSize: 11 }}>
                            {log.eseguito_at
                              ? parseTimestampDB(log.eseguito_at).toLocaleString("it-IT",
                                  { hour: "2-digit", minute: "2-digit" })
                              : "—"}
                          </span>
                          {/* Icona + Tipo */}
                          <span style={{ width: 180, flexShrink: 0,
                                         display: "flex", alignItems: "center", gap: 5 }}>
                            <span style={{ fontSize: 14 }}>{tipoInfo.icon}</span>
                            <span style={{ fontWeight: 600, color: "#334155" }}
                                  title={tipoInfo.tip || ""}>
                              {tipoInfo.label}
                            </span>
                            {tipoInfo.tip && (
                              <span style={{ fontSize: 11, color: "#94A3B8", cursor: "help" }}
                                    title={tipoInfo.tip}>ℹ️</span>
                            )}
                          </span>
                          {/* Descrizione automatica — v104 */}
                          <span style={{
                            width: 360, flexShrink: 0,
                            color: "#64748B", fontSize: 12,
                            overflow: "hidden", textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }} title={getDescrizioneOperazione(log) || ""}>
                            {getDescrizioneOperazione(log) || "—"}
                          </span>
                          {/* Esito badge */}
                          {(() => {
                            const isWarning = log.esito === "warning";
                            const isNessunDato = log.esito === "nessun_dato";
                            let bg, color, testo;
                            if (isErrore) {
                              bg = "#FFEBEE"; color = "#C62828"; testo = "❌ Errore";
                            } else if (isNotificaErrori) {
                              bg = "#FFEBEE"; color = "#C62828"; testo = "🔴 Errori notificati";
                            } else if (isWarning) {
                              bg = "#FFF8E1"; color = "#F57F17"; testo = "⚠️ Anomalie rilevate";
                            } else if (isNessunDato) {
                              bg = "#E8F5E9"; color = "#2E7D32"; testo = "ℹ️ Nessun dato";
                            } else if (log.esito === "successo") {
                              bg = "#E8F5E9"; color = "#2E7D32"; testo = "✅ OK";
                            } else {
                              bg = "#FFF8E1"; color = "#F57F17"; testo = log.esito;
                            }
                            return (
                              <span style={{
                                padding: "1px 8px", borderRadius: 4,
                                fontSize: 11, fontWeight: 600,
                                background: bg, color, flexShrink: 0,
                              }}>
                                {testo}
                              </span>
                            );
                          })()}
                          {/* Record elaborati */}
                          {log.record_elaborati > 0 && (
                            <span style={{
                              fontFamily: MONO, fontSize: 11,
                              color: "#64748B", flexShrink: 0,
                            }}>
                              {log.record_elaborati} rec.
                            </span>
                          )}
                          {/* Link apri mail — solo per operazioni mail da oggi in poi */}
                          {["notifica_errori","mail_programma","mail_aggiornamento","mail_bilancio"].includes(log.tipo) && log.esito === "successo" && log.eseguito_at && parseTimestampDB(log.eseguito_at) >= new Date(new Date().toDateString()) && (
                            <span
                              onClick={(e) => { e.stopPropagation(); onNavigate && onNavigate("mail-sistema", { mailId: log.id }); }}
                              title="Apri nella sezione Mail di sistema"
                              style={{
                                fontSize: 11, color: "#3B82F6", fontWeight: 600,
                                cursor: "pointer", flexShrink: 0,
                                textDecoration: "underline", marginLeft: 4,
                              }}
                            >
                              📨 Apri
                            </span>
                          )}
                          {/* Freccia espansione */}
                          <span style={{ marginLeft: "auto", fontSize: 10, color: "#94A3B8", flexShrink: 0 }}>
                            {isEspanso ? "▲" : "▼"}
                          </span>
                        </div>
                        {/* Pannello dettaglio espanso */}
                        {isEspanso && (
                          <div style={{
                            padding: "10px 16px 12px 70px",
                            background: "#F8FAFF",
                            borderBottom: "1px solid #BFDBFE",
                            borderTop: "1px solid #BFDBFE",
                          }}>
                            {log.dettaglio ? (
                              <div style={{
                                fontSize: 12, fontFamily: FONT,
                                color: isErrore ? "#991B1B" : "#334155",
                                lineHeight: 1.7, whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}>
                                {log.dettaglio.split(";").map((parte, pi) => (
                                  parte.trim() ? (
                                    <div key={pi} style={{ marginBottom: 2 }}>
                                      {isErrore ? "❌ " : "• "}{parte.trim()}
                                    </div>
                                  ) : null
                                ))}
                              </div>
                            ) : (
                              <span style={{ fontSize: 12, color: "#94A3B8", fontFamily: FONT }}>
                                Nessun dettaglio disponibile
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))
            )}
            {/* Pulsante carica altri */}
            {logHasMore && (
              <div style={{ textAlign: "center", padding: "12px 0",
                            borderTop: "1px solid #E2E8F0" }}>
                <button style={{ ...stili.btn, ...stili.btnSecondary,
                                 fontSize: 12 }}
                        onClick={() => caricaLog(true)}>
                  Mostra log precedenti
                </button>
              </div>
            )}
          </div>
        </div>
        );
      })()}


      {/* v102: Popup dettagli diff ricalcolo */}
      {showDettagliDiff && ricalcoloPending && (
        <div
          onClick={() => setShowDettagliDiff(false)}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(15, 23, 42, 0.55)", zIndex: 2000,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: "#fff", borderRadius: 12, padding: 0,
              maxWidth: 860, width: "100%", maxHeight: "85vh",
              display: "flex", flexDirection: "column",
              boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
              fontFamily: FONT,
            }}
          >
            {/* Header popup */}
            <div style={{
              padding: "14px 20px", borderBottom: "1px solid #E2E8F0",
              display: "flex", alignItems: "center", justifyContent: "space-between",
            }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
                Dettaglio variazioni — Ciclo {ricalcoloPending.ciclo_tipo || ""}
                {ricalcoloPending.ciclo_inizio && ricalcoloPending.ciclo_fine && (
                  <> ({ricalcoloPending.ciclo_inizio} / {ricalcoloPending.ciclo_fine})</>
                )}
              </span>
              <button
                onClick={() => setShowDettagliDiff(false)}
                style={{ ...stili.btn, ...stili.btnSecondary, padding: "4px 10px", fontSize: 12 }}
              >
                Chiudi
              </button>
            </div>

            {/* Corpo popup */}
            <div style={{ padding: 20, overflowY: "auto", fontSize: 13, color: "#334155" }}>
              {(() => {
                const diff = ricalcoloPending.diff_json || {};
                const nuove = Array.isArray(diff.nuove) ? diff.nuove : [];
                const eliminate = Array.isArray(diff.eliminate) ? diff.eliminate : [];
                const modificate = Array.isArray(diff.modificate) ? diff.modificate : [];

                const fmtRiga = (s) => {
                  const data = s.data_partita || "";
                  const ora = s.ora_partita ? String(s.ora_partita).slice(0, 5) : "";
                  const strategie = Array.isArray(s._strategie) && s._strategie.length > 0
                    ? s._strategie.map(st => st.nome).join(", ")
                    : "";
                  return (
                    <div style={{ marginBottom: 6, paddingLeft: 12 }}>
                      • {data} {ora} — {s.lega} — <b>{s.casa}</b> vs <b>{s.trasferta}</b>
                      {" "}— {s.mercato}
                      {s.quota !== undefined && s.quota !== null && <> @ {s.quota}</>}
                      {strategie && (
                        <div style={{ fontSize: 11, color: "#64748B", marginLeft: 12 }}>
                          Strategie: {strategie}
                        </div>
                      )}
                    </div>
                  );
                };

                return (
                  <>
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ fontWeight: 700, color: "#15803D", marginBottom: 8 }}>
                        ✅ Nuovi ingressi a mercato ({nuove.length})
                      </div>
                      {nuove.length === 0
                        ? <div style={{ paddingLeft: 12, color: "#94A3B8" }}>Nessuno</div>
                        : nuove.map((s, i) => <div key={`n-${i}`}>{fmtRiga(s)}</div>)
                      }
                    </div>

                    <div style={{ marginBottom: 16 }}>
                      <div style={{ fontWeight: 700, color: "#B91C1C", marginBottom: 8 }}>
                        ❌ Ingressi a mercato eliminati ({eliminate.length})
                      </div>
                      {eliminate.length === 0
                        ? <div style={{ paddingLeft: 12, color: "#94A3B8" }}>Nessuno</div>
                        : eliminate.map((s, i) => <div key={`e-${i}`}>{fmtRiga(s)}</div>)
                      }
                    </div>

                    <div style={{ marginBottom: 4 }}>
                      <div style={{ fontWeight: 700, color: "#B45309", marginBottom: 8 }}>
                        ✏️ Ingressi a mercato modificati ({modificate.length})
                      </div>
                      {modificate.length === 0
                        ? <div style={{ paddingLeft: 12, color: "#94A3B8" }}>Nessuno</div>
                        : modificate.map((m, i) => {
                            const d = m.dopo || {};
                            const p = m.prima || {};
                            const data = d.data_partita || "";
                            const ora = d.ora_partita ? String(d.ora_partita).slice(0, 5) : "";
                            const qPrima = p.quota;
                            const qDopo = d.quota;
                            const stPrima = p.stato || "";
                            const stDopo = d.stato || "";
                            const qCambiata = String(qPrima) !== String(qDopo);
                            const stCambiato = stPrima !== stDopo;
                            const strategie = Array.isArray(d._strategie) && d._strategie.length > 0
                              ? d._strategie.map(st => st.nome).join(", ")
                              : "";
                            return (
                              <div key={`m-${i}`} style={{ marginBottom: 8, paddingLeft: 12 }}>
                                • {data} {ora} — {d.lega} — <b>{d.casa}</b> vs <b>{d.trasferta}</b> — {d.mercato}
                                {qCambiata && (
                                  <div style={{ paddingLeft: 12, fontSize: 12 }}>
                                    Quota: {qPrima} → <b>{qDopo}</b>
                                  </div>
                                )}
                                {stCambiato && (
                                  <div style={{ paddingLeft: 12, fontSize: 12 }}>
                                    Stato: {stPrima || "—"} → <b>{stDopo || "—"}</b>
                                  </div>
                                )}
                                {strategie && (
                                  <div style={{ fontSize: 11, color: "#64748B", paddingLeft: 12 }}>
                                    Strategie: {strategie}
                                  </div>
                                )}
                              </div>
                            );
                          })
                      }
                    </div>
                  </>
                );
              })()}
            </div>

            {/* Footer popup */}
            <div style={{
              padding: "12px 20px", borderTop: "1px solid #E2E8F0",
              display: "flex", gap: 8, justifyContent: "flex-end",
            }}>
              <button
                style={{ ...stili.btn, ...stili.btnSecondary, fontSize: 12 }}
                onClick={ignoraPending}
                disabled={ignorandoPending}
              >
                {ignorandoPending ? "Ignorando…" : "✓ Ignora"}
              </button>
              <button
                style={{ ...stili.btn, ...stili.btnPrimary, fontSize: 12 }}
                onClick={inviaMailAggiornamento}
              >
                📧 Invia mail
              </button>
            </div>
          </div>
        </div>
      )}


      {/* v103: Popup anteprima mail ripristino ciclo (Opzione C — lista verticale espandibile) */}
      {showAnteprimaMail && (
        <div
          onClick={() => { if (!inviandoMail) setShowAnteprimaMail(false); }}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(15, 23, 42, 0.55)", zIndex: 2100,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: "#fff", borderRadius: 12, padding: 0,
              maxWidth: 920, width: "100%", maxHeight: "85vh",
              display: "flex", flexDirection: "column",
              boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
              fontFamily: FONT,
            }}
          >
            {/* Header popup */}
            <div style={{
              padding: "14px 20px", borderBottom: "1px solid #E2E8F0",
              display: "flex", alignItems: "center", justifyContent: "space-between",
            }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
                  Anteprima mail ripristino ciclo
                </div>
                <div style={{ fontSize: 12, color: "#64748B", marginTop: 2 }}>
                  {caricandoAnteprima
                    ? "Caricamento anteprima…"
                    : `${anteprimeMail.length} mail ${anteprimeMail.length === 1 ? "pronta" : "pronte"} per l'invio`}
                </div>
              </div>
              <button
                onClick={() => { if (!inviandoMail) setShowAnteprimaMail(false); }}
                disabled={inviandoMail}
                style={{ ...stili.btn, ...stili.btnSecondary, padding: "4px 10px", fontSize: 12 }}
              >
                Chiudi
              </button>
            </div>

            {/* Corpo popup */}
            <div style={{ padding: 20, overflowY: "auto", fontSize: 13, color: "#334155" }}>
              {caricandoAnteprima ? (
                <div style={{ textAlign: "center", padding: 40, color: "#64748B" }}>
                  Caricamento anteprima in corso…
                </div>
              ) : anteprimeMail.length === 0 ? (
                <div style={{ textAlign: "center", padding: 40, color: "#94A3B8" }}>
                  Nessuna mail da inviare.
                </div>
              ) : (
                anteprimeMail.map((m) => {
                  const espansa = !!sezioniEspanse[m.strategia_id];
                  const dest = Array.isArray(m.destinatari) ? m.destinatari : [];
                  return (
                    <div
                      key={m.strategia_id}
                      style={{
                        border: "1px solid #E2E8F0", borderRadius: 8,
                        marginBottom: 10, overflow: "hidden",
                      }}
                    >
                      {/* Intestazione card (sempre visibile) */}
                      <div
                        onClick={() => setSezioniEspanse(s => ({
                          ...s, [m.strategia_id]: !s[m.strategia_id],
                        }))}
                        style={{
                          cursor: "pointer", padding: "10px 14px",
                          background: "#F8FAFC",
                          borderBottom: espansa ? "1px solid #E2E8F0" : "none",
                          display: "flex", alignItems: "center", gap: 10,
                        }}
                      >
                        <span style={{ fontSize: 13, color: "#475569" }}>
                          {espansa ? "▼" : "▶"}
                        </span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#1E293B" }}>
                            Strategia {m.strategia_nome}
                          </div>
                          <div style={{ fontSize: 11, color: "#64748B", marginTop: 2 }}>
                            Destinatari: {dest.length > 0 ? dest.join(", ") : <em>nessuno</em>}
                          </div>
                          <div style={{ fontSize: 11, color: "#64748B", marginTop: 2 }}>
                            {m.num_nuove} nuovi · {m.num_eliminate} eliminati · {m.num_modificate} modificati
                          </div>
                        </div>
                      </div>

                      {/* Corpo card (espanso) */}
                      {espansa && (
                        <div style={{ padding: 14 }}>
                          <div style={{ fontSize: 12, color: "#64748B", marginBottom: 4 }}>
                            <strong>Oggetto:</strong> {m.oggetto}
                          </div>
                          <div style={{
                            border: "1px solid #E2E8F0", borderRadius: 6,
                            background: "#fff", overflow: "hidden",
                          }}>
                            <iframe
                              title={`anteprima-${m.strategia_id}`}
                              srcDoc={m.body_html || ""}
                              style={{
                                width: "100%", minHeight: 320, border: "none",
                                display: "block",
                              }}
                            />
                          </div>
                          {dest.length === 0 && (
                            <div style={{
                              marginTop: 8, fontSize: 11, color: "#B45309",
                              background: "#FEF3C7", padding: "6px 10px", borderRadius: 6,
                            }}>
                              ⚠️ Nessun destinatario configurato: questa mail non verrà inviata.
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>

            {/* Footer popup */}
            <div style={{
              padding: "12px 20px", borderTop: "1px solid #E2E8F0",
              display: "flex", gap: 8, justifyContent: "flex-end",
            }}>
              <button
                style={{ ...stili.btn, ...stili.btnSecondary, fontSize: 12 }}
                onClick={() => setShowAnteprimaMail(false)}
                disabled={inviandoMail}
              >
                Annulla
              </button>
              <button
                style={{ ...stili.btn, ...stili.btnPrimary, fontSize: 12 }}
                onClick={confermaInvioMail}
                disabled={inviandoMail || caricandoAnteprima || anteprimeMail.length === 0}
              >
                {inviandoMail
                  ? "Invio in corso…"
                  : `✉️ Conferma invio — ${anteprimeMail.length} ${anteprimeMail.length === 1 ? "mail" : "mail"}`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── v128: Popup conferma multi-invio (Versione B) ── */}
      {confermaInvioSel && (
        <div
          onClick={() => setConfermaInvioSel(null)}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(15, 23, 42, 0.55)", zIndex: 2200,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: "#fff", borderRadius: 12, padding: 0,
              maxWidth: 480, width: "100%",
              boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
              fontFamily: FONT,
            }}
          >
            <div style={{
              padding: "14px 20px", borderBottom: "1px solid #E2E8F0",
              display: "flex", alignItems: "center", gap: 10,
            }}>
              <span style={{ fontSize: 18 }}>⚠️</span>
              <span style={{ fontSize: 15, fontWeight: 700, color: "#1E293B" }}>
                Selezione già inviata al Diario
              </span>
            </div>

            <div style={{ padding: "18px 20px" }}>
              {(() => {
                const invii = conteggiDiario[String(confermaInvioSel.id)] || [];
                return (
                  <>
                    <p style={{ margin: "0 0 12px", fontSize: 13, color: "#1E293B", lineHeight: 1.6 }}>
                      Questa selezione è già stata inviata al Diario{" "}
                      <b>{invii.length} {invii.length === 1 ? "volta" : "volte"}</b>:
                    </p>
                    <ol style={{ margin: "0 0 14px 18px", padding: 0, fontSize: 12, color: "#374151", lineHeight: 1.7 }}>
                      {invii.map((inv, idx) => {
                        const dt = inv.data_invio ? new Date(inv.data_invio) : null;
                        const dtStr = dt
                          ? `${dt.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" })} alle ${dt.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}`
                          : "—";
                        // v138: prefisso mercato per sistemi multi-mercato
                        const merc = inv.mercato && inv.tipo_punta_banca
                          ? `${inv.tipo_punta_banca === "Banca" ? "Banca" : "Punta"} ${inv.mercato} — `
                          : "";
                        return (
                          <li key={inv.id || idx}>
                            <b>{merc}</b>{dtStr}
                            {inv.bookmaker_nome ? ` — ${inv.bookmaker_nome}` : ""}
                            {inv.quota_effettiva != null ? ` — quota ${Number(inv.quota_effettiva).toFixed(2).replace(".", ",")}` : ""}
                          </li>
                        );
                      })}
                    </ol>
                    <div style={{
                      background: "#F1F5F9", borderRadius: 8, padding: "10px 12px",
                      marginBottom: 12, fontSize: 12, color: "#374151",
                    }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                        <span style={{ color: "#64748B" }}>Partita</span>
                        <span style={{ fontWeight: 600 }}>{confermaInvioSel.casa} – {confermaInvioSel.trasferta}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                        <span style={{ color: "#64748B" }}>Data</span>
                        <span>{fmtData(confermaInvioSel.data)} · {fmtOra(confermaInvioSel.ora) || "—"}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ color: "#64748B" }}>Sistema</span>
                        <span style={{ color: "#6366F1" }}>{confermaInvioSel.sistema_nome || "—"}</span>
                      </div>
                    </div>
                    <p style={{ margin: 0, fontSize: 12, color: "#64748B", lineHeight: 1.6 }}>
                      {(() => {
                        // v138: testo dinamico in base al contesto
                        const s = confermaInvioSel;
                        const mercati = (s && Array.isArray(s.mercati)) ? s.mercati : [];
                        if (mercati.length > 1) {
                          const idx = calcolaProssimoIndiceMercato(s);
                          if (idx !== null && mercati[idx]) {
                            return `Manca ancora il mercato ${mercati[idx].mercato_label}. Clicca per completare l'invio.`;
                          }
                        }
                        return "Vuoi inviarla un'altra volta? Utile se vuoi piazzarla su un altro bookmaker o con uno stake diverso.";
                      })()}
                    </p>
                  </>
                );
              })()}
            </div>

            <div style={{
              padding: "12px 20px 16px",
              display: "flex", justifyContent: "flex-end", gap: 10,
            }}>
              <button
                style={{ ...stili.btn, ...stili.btnSecondary, fontSize: 12 }}
                onClick={() => setConfermaInvioSel(null)}
              >
                Annulla
              </button>
              <button
                style={{ ...stili.btn, ...stili.btnPrimary, fontSize: 12 }}
                onClick={onConfermaInvioDiario}
              >
                {(() => {
                  // v138: etichetta dinamica
                  // - multi-mercato con mercato non inviato → "Procedi con [label]"
                  // - altrimenti (mono, o multi tutto inviato) → testo storico
                  const s = confermaInvioSel;
                  const mercati = (s && Array.isArray(s.mercati)) ? s.mercati : [];
                  if (mercati.length > 1) {
                    const idx = calcolaProssimoIndiceMercato(s);
                    if (idx !== null && mercati[idx]) {
                      return `Procedi con ${mercati[idx].mercato_label}`;
                    }
                  }
                  return "Sì, crea nuova operazione";
                })()}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── v128: FormOperazione aperto in modalità "nuova precompilata" ── */}
      {formPrecompila && (
        <FormOperazione
          precompila={formPrecompila}
          onChiudi={() => setFormPrecompila(null)}
          onSalva={onSalvaFormDiario}
        />
      )}

      {/* ── v138: Banner "Procedi con [prossimo mercato]?" per sequenza multi-mercato ── */}
      {bannerProssimoMercato && (
        <div style={{
          position: "fixed", inset: 0,
          background: "rgba(15, 23, 42, 0.5)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 1000,
        }}>
          <div style={{
            background: "#fff", borderRadius: 12,
            padding: "24px 28px", width: 460, maxWidth: "92vw",
            fontFamily: "'DM Sans', sans-serif",
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          }}>
            <h3 style={{
              fontSize: 16, fontWeight: 700, color: "#1E293B",
              margin: "0 0 8px 0",
            }}>
              ✅ Operazione salvata
            </h3>
            <p style={{
              fontSize: 13, color: "#475569",
              margin: "0 0 18px 0", lineHeight: 1.5,
            }}>
              Il sistema <strong>{bannerProssimoMercato.selezione.sistema_nome}</strong> ha
              un altro mercato da inviare: <strong>{bannerProssimoMercato.prossimoLabel}</strong>.
              Vuoi procedere subito?
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                style={{
                  padding: "8px 14px", borderRadius: 8,
                  border: "1px solid #CBD5E1", background: "#fff",
                  color: "#475569", fontSize: 13, fontWeight: 600,
                  cursor: "pointer",
                }}
                onClick={onPiuTardiProssimoMercato}
              >
                Più tardi
              </button>
              <button
                style={{
                  padding: "8px 14px", borderRadius: 8,
                  border: "none", background: "#2563EB",
                  color: "#fff", fontSize: 13, fontWeight: 600,
                  cursor: "pointer",
                }}
                onClick={onContinuaProssimoMercato}
              >
                Continua con {bannerProssimoMercato.prossimoLabel}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
